import { animate, style, transition } from '@angular/animations';

export const animations = {
  navbarButton: [
    transition(':enter', [
      style({ transform: 'translateY(-100%)', opacity: 0 }),
      animate('150ms', style({ transform: 'translateY(0)', opacity: 1 })),
    ]),
    transition(':leave', [
      style({ transform: 'translateY(0)', opacity: 1 }),
      animate('150ms', style({ transform: 'translateY(-100%)', opacity: 0 })),
    ]),
  ],
};
